export default function SpaPageBackground() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 -z-10 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom_right,oklch(0.97_0.01_279)_0%,var(--background)_45%,oklch(0.985_0.005_279)_100%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,oklch(0.85_0_0/0.35)_1px,transparent_0)] [background-size:24px_24px]" />
      <div className="absolute -top-32 left-1/2 h-[28rem] w-[28rem] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" />
      <div className="absolute right-0 -bottom-32 h-80 w-80 rounded-full bg-primary/5 blur-[100px]" />
    </div>
  );
}
